import "./OrdersTable.css";
import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { LabOrder } from "pwapi";

import OrdersColumns from "./OrdersColumns";
import OrdersTableView from "./OrdersTableView";

type OrdersTableProps = {
  orders: LabOrder[];
  columns: any[];
  ordersWithoutSlides?: LabOrder[];
};

const OrdersTable = ({
  columns,
  orders = [],
  ordersWithoutSlides,
}: OrdersTableProps) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: orders,
      autoResetExpanded: false,
      defaultColumn: {
        sortDescFirst: true,
      },
      initialState: {
        sortBy: [{ id: "created_at", desc: false }],
      },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  return (
    <OrdersTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
    />
  );
};

export default OrdersColumns(OrdersTable, {
  hasFlagReason: true,
  canCancel: true,
  canCompleteOrder: true,
  displayClipboardButton: false,
  printSlideFromOrderButton: true,
});
